import React, { Suspense } from 'react';
import './index.css';
import './i18n';
import ReactDOM from 'react-dom/client';
import App from 'App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <Suspense fallback="Loading...">
    <App />
  </Suspense>,
);
